module.exports = __webpack_public_path__ + "img/dep_petfoodandcare@2x.1fdfe4ea.png";